import qiitaIcon from "../image/qiita-white-icon.png";

/**
 * SNS・外部アカウントへのリンク一覧。
 * iconClass(Font Awesome)か iconSrc(画像)のどちらかを指定する。
 */
export const socialLinks = [
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/tatsumi-oikawa-44a77414a/",
    iconClass: "fab fa-linkedin-in",
  },
  {
    name: "GitHub",
    url: "https://github.com/tatsumi6314",
    iconClass: "fab fa-github",
  },
  {
    name: "Qiita",
    url: "https://qiita.com/tatsumi6314",
    iconSrc: qiitaIcon,
  },
];
